import { render } from "./SingleRemittanceView.vue?vue&type=template&id=40b53624"
import script from "./SingleRemittanceView.vue?vue&type=script&lang=js"
export * from "./SingleRemittanceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__